import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0026_CSC_CAN62 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0026_CSC_CAN62',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOperatingData',
              isRead: 'true',
              interval: '1766',
              texttableentry: 'ElectricalEnergyStorageModuleOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryStateOfChargeHistogram',
              isRead: 'true',
              interval: '2185',
              texttableentry: 'BatteryStateOfChargeHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryAmbientTemperatureHistogram',
              isRead: 'true',
              interval: '2186',
              texttableentry: 'BatteryAmbientTemperatureHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureHistogram',
              isRead: 'true',
              interval: '2187',
              texttableentry: 'BatteryTemperatureHistogram',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleCoulombCounters',
              isRead: 'true',
              interval: '2335',
              texttableentry: 'BatteryModuleCoulombCounters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleTypeId',
              isRead: 'true',
              interval: '2425',
              texttableentry: 'BatteryModuleTypeId',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListLastEntry',
              isRead: 'true',
              interval: '2587',
              texttableentry: 'BatteryModuleWarrantyDataListLastEntry',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListOne',
              isRead: 'true',
              interval: '2588',
              texttableentry: 'BatteryModuleWarrantyDataListOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleWarrantyDataListTwo',
              isRead: 'true',
              interval: '2589',
              texttableentry: 'BatteryModuleWarrantyDataListTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryAmbientTemperatureHistogramTwoPointFour',
              isRead: 'true',
              interval: '2996',
              texttableentry: 'BatteryAmbientTemperatureHistogramTwoPointFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureHistogramTwoPointFour',
              isRead: 'true',
              interval: '2997',
              texttableentry: 'BatteryTemperatureHistogramTwoPointFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareSignalCheckCsc',
              isRead: 'true',
              interval: '2998',
              texttableentry: 'HardwareSignalCheckCsc',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
